import React, { useState, useEffect } from "react";
import { Container, Grid } from "@mantine/core";
import { MantineReactTable } from "mantine-react-table";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import {
  GetUser,
  getDepId,
  getOrgId,
  HEADERS,
  GetNotificationPreference,
  UpdateNotificationPreference,
} from "../../../api";

function NotificationPreferences() {
  const [userCheckboxes, setUserCheckboxes] = useState({});
  const [selectedUser, setSelectedUser] = useState("");
  const [users, setUsers] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [pageSize, setPageSize] = useState(5);
  const [page, setPage] = useState(0);
  useEffect(() => {
    const fetchUserData = async () => {
      const orgID = getOrgId();
      const DepId = getDepId();

      try {
        const requestData = { org_id: orgID, dept_id: DepId };
        const response = await axios.post(GetUser, requestData, {
          headers: HEADERS,
        });
        // $&

        if (response.data.response_code === "0000") {
          // Initialize userCheckboxes state with saved or default values

          const initialCheckboxes = {};
          response.data.data.forEach((user) => {
            // Retrieve saved data from localStorage or use default values
            const savedData =
              JSON.parse(
                localStorage.getItem(`userCheckboxes_${user.user_id}`)
              ) || {};

            initialCheckboxes[user.user_id] = {
              attachment_add_notification:
                savedData.attachment_add_notification ||
                user.attachment_add_notification ||
                false,
              daily_leave_approval_pending_notification:
                savedData.daily_leave_approval_pending_notification ||
                user.daily_leave_approval_pending_notification ||
                false,
              employee_add_notification:
                savedData.employee_add_notification ||
                user.employee_add_notification ||
                false,
              instant_leave_approval_pending_notification:
                savedData.instant_leave_approval_pending_notification ||
                user.instant_leave_approval_pending_notification ||
                false,
              leave_approved_notification:
                savedData.leave_approved_notification ||
                user.leave_approved_notification ||
                false,
              leave_rejected_notification:
                savedData.leave_rejected_notification ||
                user.leave_rejected_notification ||
                false,
              sms_notification:
                savedData.sms_notification || user.sms_notification || false,
              email_notification:
                savedData.email_notification ||
                user.email_notification ||
                false,
            };
          });

          setUserCheckboxes(initialCheckboxes);
          setUsers(response.data.data);
        } else {
          console.error("Error fetching user data. Please try again later.");
        }
      } catch (error) {
        console.error("An error occurred while fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  useEffect(() => {
    // Fetch notification preferences when selectedUser changes
    const fetchNotificationPreferences = async () => {
      try {
        const requestData = { user_id: selectedUser };
        const response = await axios.post(
          GetNotificationPreference,
          requestData,
          { headers: HEADERS }
        );
        // $&

        // Update userCheckboxes state with fetched notification preferences
        setUserCheckboxes({
          ...userCheckboxes,
          [selectedUser]: response.data.data[0], // assuming the response is an object with checkbox values
        });
      } catch (error) {
        console.error(
          "An error occurred while fetching notification preferences:",
          error
        );
      }
    };

    if (selectedUser) {
      fetchNotificationPreferences();
    }
  }, [selectedUser]);

  const handleSelectChange = (event) => {
    const selectedUserID = event.target.value;
    setSelectedUser(selectedUserID);
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setUserCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [selectedUser]: {
        ...prevCheckboxes[selectedUser],
        [name]: checked,
      },
    }));
  };

  const UpdateBtn = async () => {
    // Display update confirmation dialog
    Swal.fire({
      title: "Update Confirmation",
      text: "Are you sure you want to update?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "",
      cancelButtonColor: "grey",
      confirmButtonText: "Update",
    }).then(async (result) => {
      // Check if the user confirmed the update
      if (result.isConfirmed) {
        try {
          // Prepare the request body with user ID and notification preferences
          const requestBody = {
            user_id: selectedUser,
            ...userCheckboxes[selectedUser],
          };

          // Make the API call to update notification preferences
          const response = await axios.post(
            UpdateNotificationPreference,
            requestBody,
            { headers: HEADERS }
          );
          // $&

          // Check the response code from the server
          if (response.data.response_code === "0000") {
            // Display success message if the update is successful
            Swal.fire(
              "Updated!",
              "Notification preferences have been updated.",
              "success"
            );
          } else {
            // Display error message if the update fails
            console.error(
              "Error updating notification preferences. Please try again later."
            );
            console.error("Server response:", response.data);
          }
        } catch (error) {
          // Handle any errors that occur during the API call
          console.error(
            "An error occurred while updating notification preferences:",
            error
          );
        }
      }
    });
  };

  const tableData = [
    {
      location_name: "Attachment Add Notification",
      edit: (
        <div>
          <input
            type="checkbox"
            name="attachment_add_notification"
            onChange={handleCheckboxChange}
            checked={
              userCheckboxes[selectedUser]?.attachment_add_notification || false
            }
          />
        </div>
      ),
    },
    {
      location_name: "Daily Leave Approval Pending Notification",
      edit: (
        <div>
          <input
            type="checkbox"
            name="daily_leave_approval_pending_notification"
            onChange={handleCheckboxChange}
            checked={
              userCheckboxes[selectedUser]
                ?.daily_leave_approval_pending_notification || false
            }
          />
        </div>
      ),
    },
    {
      location_name: "Employee Add Notification",
      edit: (
        <div>
          <input
            type="checkbox"
            name="employee_add_notification"
            onChange={handleCheckboxChange}
            checked={
              userCheckboxes[selectedUser]?.employee_add_notification || false
            }
          />
        </div>
      ),
    },
    {
      location_name: "Instant Leave Approval Pending Notification",
      edit: (
        <div>
          <input
            type="checkbox"
            name="instant_leave_approval_pending_notification"
            onChange={handleCheckboxChange}
            checked={
              userCheckboxes[selectedUser]
                ?.instant_leave_approval_pending_notification || false
            }
          />
        </div>
      ),
    },
    {
      location_name: "Leave Approved Notification",
      edit: (
        <div>
          <input
            type="checkbox"
            name="leave_approved_notification"
            onChange={handleCheckboxChange}
            checked={
              userCheckboxes[selectedUser]?.leave_approved_notification || false
            }
          />
        </div>
      ),
    },
    {
      location_name: "Leave Rejected Notification",
      edit: (
        <div>
          <input
            type="checkbox"
            name="leave_rejected_notification"
            onChange={handleCheckboxChange}
            checked={
              userCheckboxes[selectedUser]?.leave_rejected_notification || false
            }
          />
        </div>
      ),
    },
    {
      location_name: "SMS Notification",
      edit: (
        <div>
          <input
            type="checkbox"
            name="sms_notification"
            onChange={handleCheckboxChange}
            checked={userCheckboxes[selectedUser]?.sms_notification || false}
          />
        </div>
      ),
    },
    {
      location_name: "Email Notification",
      edit: (
        <div>
          <input
            type="checkbox"
            name="email_notification"
            onChange={handleCheckboxChange}
            checked={userCheckboxes[selectedUser]?.email_notification || false}
          />
        </div>
      ),
    },
  ];

  const tableColumns = [
    {
      accessorKey: "location_name",
      header: "Email Notification",
    },
    {
      accessorKey: "edit",
      header: "Enable / Disable",
    },
  ];
  const paginatedData = tableData.slice(page * pageSize, (page + 1) * pageSize);
  const startRow = page * pageSize + 1;
  const endRow = Math.min((page + 1) * pageSize, tableData.length);
  const totalRows = tableData.length;

  const handlePageChange = (newPage) => setPage(newPage);

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0);
  };

  return (
    <div className="">
      <div>
        <span className="breadcrumb d-flex gap-2">
          <Link
            className="previou-link text-decoration-none"
            to="/other-setting"
          >
            Other Setting
          </Link>
          <span>/</span>
          <span className="current-link text-decoration-none">
            Email Notification
          </span>
        </span>
      </div>
      <div className="">
        <span className="title">Email Notification</span>
        <div className="border rounded p-3 mt-1">
          <div className=" col-md-12 ">
            <label>Employee</label>
            <select
              className="form-select mt-1"
              value={selectedUser}
              onChange={handleSelectChange}
            >
              <option value="" disabled>
                Select a user
              </option>
              {users.map((user) => (
                <option
                  key={user.user_id}
                  value={user.user_id}
                  className="custom-dropdown-item"
                >
                  {`${user.first_name} ${user.last_name}`} (
                  {`${user.employee_code}`})
                </option>
              ))}
            </select>
          </div>
        </div>
        {selectedUser && !showTable && (
          <div className="mt-3">
            <MantineReactTable
              columns={tableColumns}
              data={paginatedData}
              enablePagination={false}
              enableColumnFilters={true}
              enableSorting={true}
              enableFullScreenToggle={false}
              enableColumnOrdering={true}
              enableGlobalFilter={true}
              enableRowSelection={false}
              mantineTableBodyCellProps={{
                style: {
                  backgroundColor: "#C8E3EC60",
                  color: "#505050",
                  border: "0.5px solid #fff",
                  padding: "10px",
                },
              }}
              mantineTableHeadCellProps={{
                style: {
                  backgroundColor: "#2d7d9f",
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#fff",
                  border: "1px solid #fff",
                },
              }}
              mantineTableBodyRowProps={(row) => ({
                style: {
                  backgroundColor: row.index % 2 === 0 ? "#f9f9f9" : "#fff",
                },
              })}
            />
            <div className="pagination-container border p-2 d-flex flex-wrap justify-content-between align-items-center gap-3">
              <div className="d-flex align-items-center gap-2">
                <span style={{ fontSize: "14px" }}>Items per page:</span>
                <select
                  className="form-select"
                  style={{ width: "110px" }}
                  value={pageSize}
                  onChange={(e) =>
                    handlePageSizeChange(parseInt(e.target.value))
                  }
                >
                  <option value={5}>5 rows</option>
                  <option value={10}>10 rows</option>
                  <option value={20}>20 rows</option>
                  <option value={50}>50 rows</option>
                  <option value={100}>100 rows</option>
                </select>
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <span style={{ fontSize: "14px" }}>
                  {totalRows === 0
                    ? "Showing 0 to 0 of 0 entries"
                    : `Showing ${startRow} - ${endRow} of ${totalRows} entries`}
                </span>
              </div>
              <div className="d-flex justify-content-center align-items-center gap-3">
                <button
                  className="previous-button"
                  onClick={() => handlePageChange(page - 1)}
                  disabled={page === 0}
                >
                  Previous
                </button>
                <button
                  className="add-button text-center justify-content-center"
                  style={{ width: "100px" }}
                  onClick={() => handlePageChange(page + 1)}
                  disabled={(page + 1) * pageSize >= tableData.length}
                >
                  Next
                </button>
              </div>
            </div>

            <div className="lastbuttonSection">
              <button
                className="add-button justify-content-center"
                style={{ width: "120px" }}
                onClick={UpdateBtn}
              >
                Update
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default NotificationPreferences;
